import clsx from "clsx";
import React, { FC } from "react";

import * as styles from "./ListStyleMarker.module.css";

export const ListStyleMarker: FC<React.HTMLAttributes<HTMLSpanElement>> = ({ className, ...props }) => (
  <span className={clsx(styles.container, className)} {...props}>
    <span className={styles.marker} />
  </span>
);
